import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useFetcher } from '../../graphql';
import { ApiKeyCacheKey } from './cacheKeys';

export const useRegenerateApiKey = () => {
  const queryClient = useQueryClient();
  const fetcherFn = useFetcher(REGENERATE_API_KEY);

  return useMutation({
    mutationFn: async () => {
      const data = await fetcherFn({});
      return data.apiKey.regenerateApiKey;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ApiKeyCacheKey });
    },
  });
};

const REGENERATE_API_KEY = `
  mutation REGENERATE_API_KEY {
    apiKey {
      regenerateApiKey {
        plaintextKey
        keyPrefix
        createdAt
      }
    }
  }
`;
